import { Box, Button, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import CustomTypography from '../../ui/atoms/CustomTypography';
import { contextValue } from '../../constants';
import useQueryObject from '../../hooks/useQueryObject';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import useGetLuggage from './hooks/getLuggage';
import { RootState } from '../../redux/Store';
import { getScriptData as getCorescriptData } from '../../redux/reducer/coreScriptReducer';
type BadgeCountProps = {
  count: any;
};

const BadgeCount = ({ count }: BadgeCountProps) => {
  if (count === undefined || count === null || count < 1) {
    return <span style={{ display: 'none' }}></span>;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        padding: '10px 15px',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center',
        justifyContent: 'center',
        width: '30px',
        height: '30px',
        backgroundColor: '#F35625',
        borderRadius: '50%',
        color: '#fff',
        fontSize: '11px',
        marginLeft: '8px',
      }}
    >
      <CustomTypography
        variant='body1'
        sx={{
          color: 'white',
          fontFamily: 'Montserrat',
          fontSize: '11px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: 'normal',
          textTransform: 'capitalize',
        }}
      >
        {count}
      </CustomTypography>
    </Box>
  );
};

export default BadgeCount;
